<h3 mat-dialog-title>{{ data.title || 'Template Preview' }}</h3>
<div mat-dialog-content>
  <p *ngIf="data.subject" class="preview-subject"><strong>Subject:</strong> {{ data.subject }}</p>
  <div class="preview-wrapper">
    <div [innerHTML]="safeContent"></div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</div>
